import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function getCities() {
  const { data } = await axios.get(`${API}/cities`);
  return data;
}

export async function geocodeCity(q) {
  const { data } = await axios.get(`${API}/geocode`, { params: { q } });
  return data;
}

export async function getResults(cityObjects) {
  const { data } = await axios.post(`${API}/results`, {
    cities: cityObjects.map((c) => ({
      id: c.id || "",
      name: c.name,
      lat: c.lat,
      lon: c.lon,
      bbox: c.bbox || null,
    })),
  });
  return data;
}

export async function startSearch(cityObjects) {
  const { data } = await axios.post(`${API}/search`, {
    cities: cityObjects.map((c) => ({
      id: c.id || "",
      name: c.name,
      lat: c.lat,
      lon: c.lon,
      bbox: c.bbox || null,
    })),
  });
  return data;
}

export async function getSearchStatus(jobId) {
  const { data } = await axios.get(`${API}/search/status`, { params: { job_id: jobId } });
  return data;
}

export async function createGuideCheckout(originUrl) {
  const { data } = await axios.post(`${API}/payments/checkout`, { origin_url: originUrl });
  return data; // { checkout_url, session_id }
}

export async function getPaymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}

export function guideDownloadUrl(sessionId) {
  return `${API}/guide/download?session_id=${encodeURIComponent(sessionId)}`;
}

export async function generateEmail(payload) {
  const { data } = await axios.post(`${API}/generate-email`, payload);
  return data;
}
